import React, { useCallback } from 'react'
import { Stack, Typography, alpha, styled } from '@mui/material'
import ExperienceRatingScale from '../ExperienceRatingScale'
import ExperienceRatingOpenResponse from '../ExperienceRatingOpenResponse'
import { ExperienceRating } from '../ExperienceRatingScale/types'

const FEEDBACK_TEXT_ID = 'student-feedback-text'

interface Props {
  selectedRate: ExperienceRating
  feedbackText?: string
  feedbackType: string
  openResponse?: string
  setOpenResponse?: (value: string) => void
  onChangeFeedbackRating: (value: ExperienceRating) => void
  disabled?: boolean
}

const StudentFeedbackView: React.FC<Props> = ({
  selectedRate,
  feedbackText,
  feedbackType,
  openResponse,
  setOpenResponse,
  onChangeFeedbackRating,
  disabled = false,
}) => {
  const isOpenResponseType = feedbackType === 'OPEN_RESPONSE_RATING'

  const handleOpenResponseChange = useCallback(
    (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      setOpenResponse?.(e.target.value)
    },
    [setOpenResponse],
  )

  return (
    <FeedbackContainer alignItems='center' spacing={3}>
      {feedbackText && (
        <FeedbackTitle id={FEEDBACK_TEXT_ID} variant='body1'>
          {feedbackText}
        </FeedbackTitle>
      )}

      <Stack direction='row' gap={2}>
        <ExperienceRatingScale
          disabled={disabled}
          selectedRate={selectedRate}
          onChange={onChangeFeedbackRating}
          {...(feedbackText ? { 'aria-labelledby': FEEDBACK_TEXT_ID } : {})}
        />
      </Stack>

      {isOpenResponseType && (
        <ExperienceRatingOpenResponse
          response={openResponse}
          onChange={handleOpenResponseChange}
          disabled={disabled}
        />
      )}
    </FeedbackContainer>
  )
}

const FeedbackContainer = styled(Stack)(({ theme }) => ({
  padding: theme.spacing(6, 19, 8),
  backgroundColor: alpha(theme.palette.grey[50], 0.5),
}))

const FeedbackTitle = styled(Typography)(() => ({
  textAlign: 'center',
}))

export default StudentFeedbackView
